// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_d9-2";
export var aiChatCartContainerExit = "_d9-4";
export var aiChatContainerLarge = "_d9-0";
export var aiChatContainerSmall = "_d9-1";
export var aiChatIcon = "_d9-6";
export var slideInFromRight = "_d9-3";
export var slideOutToRight = "_d9-5";